module.exports = __webpack_public_path__ + "static/media/cq_tel_fisso.89bc2492.svg";